import React from "react";
import PropTypes from "prop-types";

import MDBox from "shared/components/MDBox";
import TableTagsContent from "./TableTagsContent";

function TableTags({ refreshFlag, onError, lot }) {
  return (
    <MDBox>
      <MDBox mb={2}></MDBox>
      <TableTagsContent refreshFlag={refreshFlag} onError={onError} lot={lot} />
    </MDBox>
  );
}

TableTags.propTypes = {
  refreshFlag: PropTypes.bool,
  lot: PropTypes.number,
  onError: PropTypes.func,
};

TableTags.defaultProps = {
  refreshFlag: false,
  lot: null,
  onError: null,
};

export default TableTags;
